import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { formatNisAmount, mapSpendPeriodsToChartData } from '../../utils/labData';

/** Neutral glass primary green. Replaces the previous Material blue bar. */
const SPEND_BAR_FILL = '#198754';

/**
 * Monthly spend bar chart from the by-period API (`period_start` + `total_nis`).
 *
 * @param {Object} props
 * @param {Array} [props.periods]
 * @param {'month'|'quarter'|'year'} [props.granularity]
 */
const SpendOverTimeChart = ({ periods = [], granularity = 'month' }) => {
  const chartData = mapSpendPeriodsToChartData(periods, granularity);

  return (
    <div className="glass-panel lab-data-chart-card">
      <h3 className="lab-data-section-title">Spend over time</h3>
      {chartData.length === 0 ? (
        <div className="glass-empty">No spend data for this period.</div>
      ) : (
        <ResponsiveContainer width="100%" height={320}>
          <BarChart
            data={chartData}
            margin={{ top: 8, right: 16, left: 8, bottom: 8 }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="label"
              interval={0}
              tick={{ fontSize: 12 }}
              height={48}
            />
            <YAxis tick={{ fontSize: 12 }} />
            <Tooltip
              formatter={value => formatNisAmount(value)}
              labelStyle={{ fontWeight: 600 }}
            />
            <Bar dataKey="amount" fill={SPEND_BAR_FILL} radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

export default SpendOverTimeChart;
